import * as React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';

import loadable from '@common/react/loadable/loadableSettings';
import NotFoundRoute from '@common/react/components/Routes/NotFoundRoute';

import Layout from '@app/components/Layout';
import { MainRoute } from '@app/components/Routes/MainRoute';

const Home = loadable(() => import(/* webpackChunkName: "HomePage" */ '@app/components/Pages/Home/Home'));
const Contacts = loadable(() => import(/* webpackChunkName: "ContactsPage" */ '@app/components/Pages/Contacts/Contacts'));
const Section = loadable(() => import(/* webpackChunkName: "SectionPage" */ '@app/components/Pages/Section/Section'));
const DoctorList = loadable(() => import(/* webpackChunkName: "DoctorListPage" */ '@app/components/Pages/DoctorList/DoctorList'));
const BeforeAfter = loadable(() => import(/* webpackChunkName: "BeforeAfterPage" */ '@app/components/Pages/BeforeAfterList/BeforeAfter'));
const DoctorPage = loadable(() => import(/* webpackChunkName: "DoctorPage" */ '@app/components/Pages/DoctorList/DoctorPage'));
const ClinicPage = loadable(() => import(/* webpackChunkName: "ClinicPage" */ '@app/components/Pages/Clinic/ClinicPage'));
const BlogPage = loadable(() => import(/* webpackChunkName: "BlogPage" */ '@app/components/Pages/Blog/Blog'));
const FaqListPage = loadable(() => import(/* webpackChunkName: "FaqListPage" */ '@app/components/Pages/Faq/Faq'));
const SingleFaq = loadable(() => import(/* webpackChunkName: "SingleFaqPage" */ '@app/components/Pages/Faq/FaqPage'));
const Specials = loadable(() => import(/* webpackChunkName: "Specials" */ '@app/components/Pages/Specials/Specials'));
const Sale = loadable(() => import(/* webpackChunkName: "Sale" */ '@app/components/Pages/Sale/Sale'));

export const baseRoutes = (
	<>
		<Route
			path="/"
			element={<MainRoute />}
		>
			<Route path="/" element={<Home />} />
			<Route path="/es" element={<Home />} />
			<Route path="/home" element={<Home />} />
			<Route path="/es/home" element={<Home />} />
			<Route path="/contacts" element={<Contacts />} />
			<Route path="/es/contacts" element={<Contacts />} />
			<Route path="/es/contactos" element={<Contacts />} />
			<Route path="/specials/:page?" element={<Specials />} />
			<Route path="/es/specials/:page?" element={<Specials />} />
			<Route path="/doctors" element={<DoctorList />} />
			<Route path="/es/doctors" element={<DoctorList />} />
			<Route path="/practica/doctors" element={<DoctorList />} />
			<Route path="/practice/doctors" element={<DoctorList />} />
			<Route path="/es/practica/doctors" element={<DoctorList />} />
			<Route path="/es/practice/doctors" element={<DoctorList />} />
			<Route path="/beforeafter" element={<BeforeAfter />} />
			<Route path="/es/beforeafter" element={<BeforeAfter />} />
			<Route path="/es/doctor/:path?" element={<DoctorPage />} />
			<Route path="/doctor/:path?" element={<DoctorPage />} />
			<Route path="/clinic/:path?" element={<ClinicPage />} />
			<Route path="/es/clinic/:path?" element={<ClinicPage />} />
			<Route path="/faq" element={<FaqListPage />} />
			<Route path="/faq/:page" element={<SingleFaq />} />
			<Route path="/es/faq" element={<FaqListPage />} />
			<Route path="/es/faq/:page" element={<SingleFaq />} />
			<Route path="/blog" element={<BlogPage />} />
			<Route path="/es/blog" element={<BlogPage />} />
			<Route path="/es/sale/:path" element={<Sale />} />
			<Route path="/sale/:path" element={<Sale />} />
			<Route path="/:path/*" element={<Section />} />
		</Route>
		<Route path="*" element={<NotFoundRoute openRoute={MainRoute} />} />
	</>
);

export const clientRoutes = (<Route
	element={<Layout>
		<Outlet />
	</Layout>}
>
	{baseRoutes}
</Route>);

export const routes = (<Layout>
	<Routes>
		{baseRoutes}
	</Routes>
</Layout>);
